import React from 'react';
import '../styles/footer.css';
import logo from '../Logo.png';

const Footer = () => {

    return (
        <div>
            <div className="footerContainer">
                <img src={logo} alt="" className="logo"></img>
                <p>Clusterfy <a href="privacypolicy">Privacy Policy</a> and <a href="terms">Terms and Conditions</a></p>
                <p>Contact <a href = "mailto: clusterfyapp@gmail.com">clusterfyapp@gmail.com</a> for any concerns or deletion of data</p>
            </div>
        </div>
    );

};

export default Footer;